import { colors } from 'components/styles/variables';
import Link from 'next/link';
import ReactModal from 'react-modal';
import { useTranslation } from 'react-i18next';
import {
  multiMakeModelCloseEvent,
  multiMakeModelViewEvent,
  multiMakeModelOpenAppEvent,
} from 'lib/Tracking/Srp/MultiMakeModelEvents';
import useEvents from 'lib/hooks/useEvents';
import { useEffect } from 'react';
import { useRouter } from 'next/router';

function modalStyling(): ReactModal.Styles {
  return {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      zIndex: 10000,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    content: {
      padding: '24px 20px',
      height: 'auto',
      width: '308px',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      overflow: 'hidden',
      inset: 'auto',
      borderRadius: '8px',
    },
  };
}

interface MultiVehicleModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function MultiVehicleModal({
  isOpen,
  onClose,
}: MultiVehicleModalProps): JSX.Element {
  const { t } = useTranslation();
  const logger = useEvents();
  const router = useRouter();
  const url = router.asPath;

  function handleClose(): void {
    logger.log(multiMakeModelCloseEvent({ url }));
    onClose();
  }

  useEffect(() => {
    if (isOpen) {
      logger.log(multiMakeModelViewEvent({ url }));
    }
  }, [isOpen, logger, url]);

  return (
    <ReactModal isOpen={isOpen} onRequestClose={handleClose} style={modalStyling()}>
      <div className="multi-vehicle-modal-title">{t('srp.multiVehicle.title')}</div>
      <div className="multi-vehicle-modal-text">{t('srp.multiVehicle.description')}</div>
      <div className="multi-vehicle-modal-cta-container">
        <Link
          onClick={(): void => {
            logger.log(multiMakeModelOpenAppEvent({ url }));
          }}
          href="https://apps.apple.com/us/app/autolist-used-cars-for-sale/id1058636900"
          style={{
            width: '263px',
            height: '44px',
            textDecoration: 'none',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '4px',
            background: colors.ALR1,
            border: 'none',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: '600',
            lineHeight: '22px',
            letterSpacing: '0.2px',
            color: colors.WHITE,
            marginBottom: '16px',
          }}
        >
          {t('srp.multiVehicle.download')}
        </Link>
        <button className="multi-vehicle-modal-cta later-cta" onClick={handleClose}>
          {t('srp.multiVehicle.okay')}
        </button>
      </div>
      <style jsx>{`
        .downloadLink {
          width: 263px;
        }

        .multi-vehicle-modal-title {
          font-size: 18px;
          font-style: normal;
          font-weight: 700;
          line-height: 22px;
          letter-spacing: 0.2px;
          margin-bottom: 16px;
          text-align: center;
        }
        .multi-vehicle-modal-text {
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: 0.2px;
          text-align: center;
          margin-bottom: 16px;
        }
        .multi-vehicle-modal-cta-container {
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
        }
        .multi-vehicle-modal-cta {
          width: 263px;
          height: 44px;
        }
        .later-cta {
          border-radius: 4px;
          border: 1px solid #d3d3d3;
          background: ${colors.WHITE};
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: 22px;
          letter-spacing: 0.2px;
        }
        .go-now-cta {
          border-radius: 4px;
          background: ${colors.ALR1};
          border: none;
        }
        .go-now-cta-text {
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: 22px;
          letter-spacing: 0.2px;
          color: ${colors.WHITE};
        }
      `}</style>
    </ReactModal>
  );
}
